import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from '../api';

const BrandingContext = createContext({ name: 'TripSoul', logo_url: null, refresh: () => {} });

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState({ name: 'TripSoul', logo_url: null });

  const refresh = useCallback(() => {
    api.get('/branding').then((res) => setBranding({
      name: res.data.name,
      logo_url: res.data.logo_url ? `${process.env.REACT_APP_BACKEND_URL}${res.data.logo_url}` : null,
    })).catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <BrandingContext.Provider value={{ ...branding, refresh }}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => useContext(BrandingContext);
